let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ap9Z2")).then(() => parcelRequire('1JL7m'));